import { MinusCircleOutlined, PlusOutlined, LinkOutlined, DisconnectOutlined, MailOutlined, EditOutlined, ToolOutlined, FileAddOutlined, DownloadOutlined, ApartmentOutlined } from "@ant-design/icons";
import { message, Row, Col, Spin, PageHeader, Space, Tooltip, Tag } from "antd";
import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  InputItem,
  InputNumberItem,
  TextAreaItem,
  CheckItem,
  DatePickerItem,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import GrupoCasillasItem from "../../../../Components/GrupoCasillasItem";
import CasillasExclusivasItem, { OPCIONES_RECOLECCION_ENTREGA } from "../../../../Components/CasillasExclusivasItem";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import SelectInsumosItem from "../../../../Components/SelectInsumosItem";
import AgregarCliente from "../../Ventas/AgregarVenta/AgregarCliente/AgregarCliente";
import LigarCotizacion from "../LigarCotizacion/LigarCotizacion";
import MandarCorreoPreCotizacion from "../MandarCorreoPreCotizacion/MandarCorreoPreCotizacion";
import ModalGenerarMatriz from "../ModalGenerarMatriz/ModalGenerarMatriz";
import ModalGenerarOrdenesProduccion from "../ModalGenerarOrdenesProduccion/ModalGenerarOrdenesProduccion";
import ModalVerMatriz from "../ModalVerMatriz/ModalVerMatriz";
import TablaMatricesPreCotizacion from "../TablaMatricesPreCotizacion/TablaMatricesPreCotizacion";
import SelectUsuarioItem from "../../../../Components/SelectUsuarioItem";
import { exportarExplosionInsumos } from "../exportarExplosionInsumos";

if (typeof document !== "undefined") {
  const styleId = "pci-scroll-thin-style";
  if (!document.getElementById(styleId)) {
    const styleEl = document.createElement("style");
    styleEl.id = styleId;
    styleEl.textContent = `
      .pci-scroll-thin {
        scrollbar-width: thin;
        scrollbar-color: #d9d9d9 transparent;
      }
      .pci-scroll-thin::-webkit-scrollbar {
        height: 6px;
      }
      .pci-scroll-thin::-webkit-scrollbar-track {
        background: transparent;
      }
      .pci-scroll-thin::-webkit-scrollbar-thumb {
        background-color: #d9d9d9;
        border-radius: 3px;
      }
      .pci-scroll-thin::-webkit-scrollbar-thumb:hover {
        background-color: #bfbfbf;
      }
    `;
    document.head.appendChild(styleEl);
  }
}

const ESTADOS_ORDEN_PRODUCCION = {
  1: { texto: "Activa", color: "blue" },
  2: { texto: "Cancelada", color: "red" },
  3: { texto: "Terminada", color: "green" },
};

const textoContacto = (valor) => (valor === undefined || valor === null ? "" : String(valor));

const contactoDeCliente = (cliente) => ({
  contactoNombre: cliente?.nombreContacto || cliente?.nombreContactoGeneral || "",
  contactoTelefono: textoContacto(cliente?.telefonoContacto || cliente?.telefono || cliente?.celular),
  contactoCorreo: cliente?.correoContacto || cliente?.correo || "",
});

/*
  Modo determinado por location.state:
    - Sin id                  → Agregar
    - { id, modo: "editar" }  → Editar
    - { id, modo: "ver" }     → Ver (solo lectura)
*/
class VistaPreCotizacionIngenieria extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    numero: "",
    cotizacionId: null,
    modalLigarVisible: false,
    modalCorreoVisible: false,
    modalClienteVisible: false,
    modalMatrizVisible: false,
    modalOrdenesVisible: false,
    matrices: [],
    ordenesProduccion: [],
  };

  get modo() {
    return this.props.location?.state?.modo || "agregar";
  }

  get id() {
    return this.props.location?.state?.id || null;
  }

  get cotizacionIdOrigen() {
    return this.props.location?.state?.cotizacionId || null;
  }

  componentDidMount() {
    if (this.id) {
      this.consultarPreCotizacion();
      this.consultarOrdenesProduccion();
    } else {
      this.consultarSiguienteNumero();
    }
  }

  consultarSiguienteNumero() {
    axios
      .post(
        "preCotizacionIngenieria/siguienteNumero",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) return;
        this.setState({ numero: `${res.data.serie || ""} ${res.data.numero || ""}`.trim() });
      });
  }

  crearCotizacion() {
    this.props.history.push("/panel/agregarCotizacion", { preCotizacionId: this.id });
  }

  consultarOrdenesProduccion() {
    axios
      .post(
        "preCotizacionIngenieria/ordenesDePreCotizacion",
        { empresaId: this.props.empresaId, preCotizacionId: this.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) this.setState({ ordenesProduccion: res.data.data || [] });
      })
      .catch(() => this.setState({ ordenesProduccion: [] }));
  }

  verOrdenProduccion(ordenId) {
    this.props.history.push("/panel/verOrdenDeProduccionPU", { id: ordenId });
  }

  verMatriz(matrizId) {
    this.setState({ matrizVista: this.state.matrices.find((matriz) => String(matriz.matrizId) === String(matrizId)) || null });
  }

  consultarPreCotizacion() {
    this.setState({ loading: true });
    axios
      .post(
        "preCotizacionIngenieria/datosPreCotizacion",
        { empresaId: this.props.empresaId, preCotizacionId: this.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
          message.error("No se encontró la pre cotización de ingeniería");
        } else if (res.data.success === 1) {
          message.warning(res.data.message);
          this.props.history.replace("/panel/preCotizacionIngenieria");
        } else {
          this.setState({
            numero: `${res.data.serie || ""} ${res.data.numero || ""}`.trim(),
            cotizacionId: res.data.cotizacionId || null,
            matrices: res.data.matricesDetalle || [],
          });
          this.formRef.current.setFieldsValue({
            ...res.data,
            matrices: undefined,
            fechaCompromiso: res.data.fechaCompromiso ? moment(res.data.fechaCompromiso) : undefined,
            fechaSolicitud: res.data.fechaSolicitud ? moment(res.data.fechaSolicitud) : undefined,
          });
        }
      });
  }

  onChangeCliente(cliente) {
    if (!cliente) return;
    this.formRef.current?.setFieldsValue(contactoDeCliente(cliente));
  }

  cerrarAgregarCliente(clienteId) {
    this.setState({ modalClienteVisible: false });
    if (!clienteId) return;
    this.formRef.current?.setFieldsValue({ clienteId });
    axios
      .post(
        "clientes/selectClientesItem",
        { empresaId: this.props.empresaId, ids: [clienteId] },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) this.onChangeCliente((res.data.clientes || [])[0]);
      });
  }

  cerrarGenerarMatriz(matriz) {
    this.setState({ modalMatrizVisible: false });
    if (!matriz) return;
    this.setState((prev) => ({ matrices: [...prev.matrices, matriz] }));
    this.agregarMaterialesPrincipales(matriz);
  }

  agregarMatrizExistente() {
    const { matrizExistenteId, piezasExistente } = this.state;
    if (!matrizExistenteId) {
      message.info("Elige una matriz");
      return;
    }
    if (this.state.matrices.some((matriz) => String(matriz.matrizId) === String(matrizExistenteId))) {
      message.info("Esa matriz ya está en la pre cotización");
      return;
    }
    this.setState({ loading: true });
    axios
      .post(
        "preCotizacionIngenieria/detalleMatrices",
        { empresaId: this.props.empresaId, matrices: [{ matrizId: matrizExistenteId, piezas: piezasExistente || 0 }] },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        const [matriz] = res.data.matrices || [];
        if (res.data.success !== 2 || !matriz) {
          message.error("No se pudo agregar la matriz");
          return;
        }
        this.setState((prev) => ({ matrices: [...prev.matrices, matriz], matrizExistenteId: undefined, piezasExistente: undefined }));
        this.agregarMaterialesPrincipales(matriz);
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("No se pudo agregar la matriz");
      });
  }

  agregarMaterialesPrincipales(matriz) {
    const principales = new Map();
    const recorrer = (componentes, cantidadPadre) =>
      (componentes || []).forEach((componente) => {
        const cantidad = (Number(componente.cantidad) || 0) * cantidadPadre;
        if (componente.principal) {
          const clave = String(componente.insumoId);
          const previo = principales.get(clave) || { insumoId: componente.insumoId, componente, cantidad: 0 };
          previo.cantidad += cantidad;
          principales.set(clave, previo);
        }
        recorrer(componente.componentes, cantidad);
      });
    recorrer(matriz.componentes, Number(matriz.piezas) || 0);
    if (principales.size === 0) return;

    const form = this.formRef.current;
    const materiales = [...(form.getFieldValue("caracteristicasMaterial") || [])];
    principales.forEach(({ insumoId, componente, cantidad }) => {
      const redondeada = Math.round(cantidad * 10000) / 10000;
      const existente = materiales.find((m) => m?.insumoId && String(m.insumoId) === String(insumoId));
      if (existente) {
        existente.cantidad = Math.round(((Number(existente.cantidad) || 0) + redondeada) * 10000) / 10000;
      } else {
        materiales.push({
          insumoId,
          descripcion: [componente.clave, componente.descripcion].filter(Boolean).join(" - "),
          cantidad: redondeada,
          unidad: componente.unidad,
        });
      }
    });
    form.setFieldsValue({ caracteristicasMaterial: materiales.map((m) => ({ ...m })) });
    message.info(`Se agregaron ${principales.size} material(es) principal(es) a "Datos del material solicitado"`);
  }

  cambiarPiezas(matrizId, piezas) {
    this.setState((prev) => ({
      matrices: prev.matrices.map((matriz) =>
        String(matriz.matrizId) === String(matrizId) ? { ...matriz, piezas: Number(piezas) || 0 } : matriz
      ),
    }));
  }

  quitarMatriz(matrizId) {
    this.setState((prev) => ({ matrices: prev.matrices.filter((matriz) => String(matriz.matrizId) !== String(matrizId)) }));
  }

  cerrarGenerarOrdenes(generadas) {
    this.setState({ modalOrdenesVisible: false });
    if (generadas) this.consultarOrdenesProduccion();
  }

  descargarExcel() {
    const form = this.formRef.current;
    const matrices = this.state.matrices.map((matriz) => ({ matrizId: matriz.matrizId, piezas: matriz.piezas }));
    const extras = (form.getFieldValue("extras") || []).filter((extra) => extra?.insumoId);
    if (matrices.length === 0 && extras.length === 0) {
      message.info("No hay matrices ni extras para explotar");
      return;
    }
    this.setState({ loading: true });
    axios
      .post(
        "preCotizacionIngenieria/explosionInsumos",
        { empresaId: this.props.empresaId, matrices, extras },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          message.error("No se pudo calcular la explosión de insumos");
          return;
        }
        const [serie, numero] = this.state.numero.split(" ");
        exportarExplosionInsumos({
          insumos: res.data.insumos,
          matrices: res.data.matrices,
          extras: res.data.extras,
          serie,
          numero,
          nombreProyecto: form.getFieldValue("nombreProyecto"),
          empresaNombre: this.props.empresaNombre,
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ loading: false });
        message.error("No se pudo generar el Excel de la explosión de insumos");
      });
  }

  atras() {
    this.props.history.goBack();
  }

  editar() {
    this.props.history.replace("/panel/vistaPreCotizacionIngenieria", { id: this.id, modo: "editar" });
  }

  verCotizacion() {
    this.props.history.push("/panel/verCotizacion", { id: this.state.cotizacionId });
  }

  abrirLigar() {
    this.setState({ modalLigarVisible: true });
  }

  cerrarLigar(seLigo) {
    this.setState({ modalLigarVisible: false });
    if (seLigo) this.consultarPreCotizacion();
  }

  desligar() {
    this.setState({ loading: true });
    axios
      .post(
        "preCotizacionIngenieria/desligarCotizacion",
        { empresaId: this.props.empresaId, preCotizacionId: this.id, cotizacionId: this.state.cotizacionId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se desligó la cotización");
          this.consultarPreCotizacion();
        } else {
          message.error("No se pudo desligar la cotización");
        }
      });
  }

  abrirCorreo() {
    this.setState({ modalCorreoVisible: true });
  }

  cerrarCorreo() {
    this.setState({ modalCorreoVisible: false });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    this.setState({ loading: true });
    const esEditar = this.modo === "editar";

    axios
      .post(
        esEditar ? "preCotizacionIngenieria/editarPreCotizacion" : "preCotizacionIngenieria/agregarPreCotizacion",
        {
          ...values,
          matrices: this.state.matrices.map((matriz) => ({ matrizId: matriz.matrizId, piezas: matriz.piezas })),
          empresaId: this.props.empresaId,
          ...(esEditar
            ? { preCotizacionId: this.id }
            : { cotizacionId: this.cotizacionIdOrigen || undefined }),
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            esEditar
              ? "Se ha editado la pre cotización de ingeniería"
              : "Se ha registrado la pre cotización de ingeniería"
          );
          if (esEditar) {
            this.atras();
          } else if (this.cotizacionIdOrigen) {
            this.props.history.push("/panel/verCotizacion", { id: this.cotizacionIdOrigen });
          } else {
            this.props.history.push("/panel/preCotizacionIngenieria");
          }
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se pudo guardar la pre cotización");
        } else {
          message.error("Hubo un error y la pre cotización no se guardó");
        }
      });
  }

  renderMatrices(soloLectura) {
    const { matrices } = this.state;

    return (
      <DynamicCardForm
        title="Matrices"
        xs={24}
        headerRight={
          <Space>
            {!soloLectura && (
              <ButtonItem type="primary" size="small" icon={<PlusOutlined />} onClick={() => this.setState({ modalMatrizVisible: true })}>
                Generar matriz
              </ButtonItem>
            )}
            <ButtonItem type="default" size="small" verde icon={<DownloadOutlined />} onClick={this.descargarExcel.bind(this)}>
              Descargar Excel
            </ButtonItem>
          </Space>
        }
      >
        {!soloLectura && (
          <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 10 }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <SelectInsumosItem
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                tiposInsumos="matrices"
                placeholder="Agregar una matriz que ya existe"
                width="100%"
                dropdownMatchSelectWidth={600}
                value={this.state.matrizExistenteId}
                onChange={(matrizExistenteId) => this.setState({ matrizExistenteId })}
              />
            </div>
            <InputNumberItem
              placeholder="Piezas"
              min={0}
              style={{ width: 120 }}
              value={this.state.piezasExistente}
              onChange={(piezasExistente) => this.setState({ piezasExistente })}
            />
            <Tooltip title="Agregar matriz">
              <ButtonItem type="primary" icon={<PlusOutlined />} onClick={this.agregarMatrizExistente.bind(this)} />
            </Tooltip>
          </div>
        )}
        <TablaMatricesPreCotizacion
          matrices={matrices}
          soloLectura={soloLectura}
          unidadTiempoProduccion={this.props.unidadTiempoProduccion}
          onCambiarPiezas={this.cambiarPiezas.bind(this)}
          onVer={this.verMatriz.bind(this)}
          onQuitar={this.quitarMatriz.bind(this)}
        />
      </DynamicCardForm>
    );
  }

  render() {
    const modo = this.modo;
    const soloLectura = modo === "ver";
    const tipoOrden = this.props.ordenesMaquila ? "Maquila" : "Producción";

    const titulos = {
      agregar: "Agregar Pre Cotización",
      editar: "Editar Pre Cotización",
      ver: `Ver Pre Cotización${this.state.numero ? ` ( ${this.state.numero} )` : ""}`,
    };

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={titulos[modo] || "Pre Cotización"}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            soloLectura ? (
              <Space>
                {this.state.cotizacionId ? (
                  <>
                    <ButtonItem type="default" lila icon={<LinkOutlined />} onClick={this.verCotizacion.bind(this)}>
                      Ver Cotización
                    </ButtonItem>
                    <ButtonItem type="default" danger icon={<DisconnectOutlined />} onClick={this.desligar.bind(this)}>
                      Desligar
                    </ButtonItem>
                  </>
                ) : (
                  <>
                    {this.props.permisoAgregarCotizaciones && (
                      <ButtonItem
                        type="default"
                        lila
                        icon={<FileAddOutlined />}
                        onClick={this.crearCotizacion.bind(this)}
                      >
                        Crear Cotización
                      </ButtonItem>
                    )}
                    <ButtonItem type="default" cyan icon={<LinkOutlined />} onClick={this.abrirLigar.bind(this)}>
                      Ligar Cotización
                    </ButtonItem>
                  </>
                )}
                <ButtonItem
                  type="default"
                  olivo
                  icon={<ToolOutlined />}
                  disabled={this.state.matrices.length === 0}
                  onClick={() => this.setState({ modalOrdenesVisible: true })}
                >
                  Generar Orden de {tipoOrden}
                </ButtonItem>
                <ButtonItem type="default" gris icon={<MailOutlined />} onClick={this.abrirCorreo.bind(this)}>
                  Mandar Correo
                </ButtonItem>
                <ButtonItem type="primary" lima onClick={this.editar.bind(this)} icon={<EditOutlined />}>
                  Editar
                </ButtonItem>
              </Space>
            ) : null
          }
        />
        {soloLectura && this.state.ordenesProduccion.length > 0 && (
          <Row gutter={16}>
            <DynamicCardForm title={`Órdenes de ${tipoOrden.toLowerCase()} generadas`} xs={24}>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "center" }}>
                {this.state.ordenesProduccion.map((orden) => {
                  const etiqueta = ESTADOS_ORDEN_PRODUCCION[orden.estado] || { texto: "—", color: "default" };
                  const matriz = (orden.matrices || [])[0];
                  return (
                    <div key={orden._id} style={{ display: "flex", alignItems: "center", gap: 4 }}>
                      <Tooltip title={[matriz?.clave, matriz?.descripcion].filter(Boolean).join(" - ")}>
                        <ButtonItem
                          type="default"
                          size="small"
                          blanco
                          icon={<ApartmentOutlined />}
                          onClick={() => this.verOrdenProduccion(orden._id)}
                        >
                          {orden.folio}
                        </ButtonItem>
                      </Tooltip>
                      <Tag color={etiqueta.color}>{etiqueta.texto}</Tag>
                    </div>
                  );
                })}
              </div>
            </DynamicCardForm>
          </Row>
        )}
        <Spin spinning={this.state.loading}>
          <Form
            ref={this.formRef}
            name="VistaPreCotizacionIngenieria"
            layoutForm="vertical"
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <Row gutter={16}>
              <DynamicCardForm title="Cotización" xs={24} lg={12} xl={12}>
                <Row gutter={16}>
                  <Col xs={24}>
                    <FormItem label="Folio" margin>
                      <InputItem value={this.state.numero} disabled placeholder="Se asigna al guardar" />
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24}>
                    <FormItem label="Nombre de la cotización" name="nombreProyecto" required={!soloLectura} margin>
                      <InputItem placeholder="Nombre de la cotización" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24}>
                    <FormItem label="Encargado" name="encargadoId" margin>
                      <SelectUsuarioItem
                        empresaId={this.props.empresaId}
                        headersToken={this.props.headersToken}
                        placeholder="Quién lo lleva"
                        style={{ width: "100%" }}
                        disabled={soloLectura}
                      />
                    </FormItem>
                  </Col>
                </Row>
                <GrupoCasillasItem label="Prioridad">
                  <FormItem name="urgente" valuePropName="checked" noStyle>
                    <CheckItem disabled={soloLectura}>Urgente</CheckItem>
                  </FormItem>
                </GrupoCasillasItem>
              </DynamicCardForm>

              <DynamicCardForm title="Cliente y fechas" xs={24} lg={12} xl={12}>
                <Row gutter={16}>
                  <Col xs={24}>
                    <div style={{ display: "flex", alignItems: "flex-end", gap: 4 }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <FormItem label="Cliente" name="clienteId" required={!soloLectura} margin>
                          <SelectClientesItem
                            empresaId={this.props.empresaId}
                            headersToken={this.props.headersToken}
                            disabled={soloLectura}
                            sinBorde
                            dropdownMatchSelectWidth={600}
                            width="100%"
                            placeholder="Cliente"
                            onChange={(clienteId, cliente) => this.onChangeCliente(cliente)}
                          />
                        </FormItem>
                      </div>
                      {!soloLectura && (
                        <Tooltip title="Alta rápida de cliente">
                          <ButtonItem
                            type="primary"
                            icon={<PlusOutlined />}
                            style={{ marginBottom: 12 }}
                            onClick={() => this.setState({ modalClienteVisible: true })}
                          />
                        </Tooltip>
                      )}
                    </div>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={8}>
                    <FormItem label="Contacto" name="contactoNombre" margin>
                      <InputItem placeholder="Con quién se ve" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                  <Col xs={24} md={8}>
                    <FormItem label="Teléfono" name="contactoTelefono" margin>
                      <InputItem placeholder="Teléfono" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                  <Col xs={24} md={8}>
                    <FormItem label="Correo" name="contactoCorreo" margin>
                      <InputItem placeholder="Correo" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={12}>
                    <FormItem label="Solicitud" name="fechaSolicitud" margin>
                      <DatePickerItem placeholder="Solicitud" style={{ width: "100%" }} disabled={soloLectura} />
                    </FormItem>
                  </Col>
                  <Col xs={12}>
                    <FormItem label="Compromiso" name="fechaCompromiso" margin>
                      <DatePickerItem placeholder="Compromiso" style={{ width: "100%" }} disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
                <GrupoCasillasItem label="Programación de entrega">
                  <FormItem name="recoleccionOEntrega" noStyle>
                    <CasillasExclusivasItem opciones={OPCIONES_RECOLECCION_ENTREGA} disabled={soloLectura} />
                  </FormItem>
                </GrupoCasillasItem>
              </DynamicCardForm>

              <DynamicCardForm title="Datos del material solicitado" xs={24}>
                <GrupoCasillasItem label="Suministra">
                  <FormItem name="materialPropio" valuePropName="checked" noStyle>
                    <CheckItem disabled={soloLectura}>La empresa</CheckItem>
                  </FormItem>
                  <FormItem name="materialPorCliente" valuePropName="checked" noStyle>
                    <CheckItem disabled={soloLectura}>El cliente</CheckItem>
                  </FormItem>
                </GrupoCasillasItem>
                <ContenedorTabla minWidth={760}>
                  <TablaGridHeader
                    soloLectura={soloLectura}
                    template={MATERIALES_TEMPLATE(soloLectura)}
                    columnas={["#", "Material solicitado", "Cantidad", "Procesos", "Características del material"]}
                  />
                  <Form.List name="caracteristicasMaterial">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.length === 0 && (
                          <div style={{ color: "#999", padding: "10px 12px" }}>
                            {soloLectura ? "Sin materiales solicitados" : "Todavía no hay materiales solicitados."}
                          </div>
                        )}
                        {fields.map(({ key, name, ...restField }, posicion) => (
                          <div key={key} style={filaTablaStyle(MATERIALES_TEMPLATE(soloLectura), posicion)}>
                            <span style={{ color: "#8c8c8c", textAlign: "center" }}>{posicion + 1}</span>
                            <FormItem {...restField} name={[name, "descripcion"]} noStyle>
                              <InputItem placeholder="1 PLACA A36, CAL.10 x 4 x 10FT" disabled={soloLectura} />
                            </FormItem>
                            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                              <FormItem {...restField} name={[name, "cantidad"]} noStyle>
                                <InputNumberItem placeholder="0" min={0} style={{ width: "100%" }} disabled={soloLectura} />
                              </FormItem>
                              <FormItem noStyle shouldUpdate>
                                {({ getFieldValue }) => (
                                  <span style={{ fontSize: 12, color: "#8c8c8c", whiteSpace: "nowrap" }}>
                                    {getFieldValue(["caracteristicasMaterial", name, "unidad"]) || ""}
                                  </span>
                                )}
                              </FormItem>
                            </div>
                            <FormItem {...restField} name={[name, "procesos"]} noStyle>
                              <TextAreaItem placeholder="Corte láser, doblez y digitalización" autoSize={{ minRows: 1, maxRows: 4 }} disabled={soloLectura} />
                            </FormItem>
                            <FormItem {...restField} name={[name, "caracteristicas"]} noStyle>
                              <InputItem placeholder="A36, CAL.10" disabled={soloLectura} />
                            </FormItem>
                            {!soloLectura && (
                              <div style={{ textAlign: "center" }}>
                                <MinusCircleOutlined
                                  style={{ fontSize: 16, color: "#ff4d4f", cursor: "pointer" }}
                                  onClick={() => remove(name)}
                                />
                              </div>
                            )}
                          </div>
                        ))}
                        {!soloLectura && (
                          <ButtonItem type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                            Agregar material solicitado
                          </ButtonItem>
                        )}
                      </>
                    )}
                  </Form.List>
                </ContenedorTabla>
              </DynamicCardForm>

              {this.renderMatrices(soloLectura)}

              <DynamicCardForm title="Extras" xs={24}>
                <ContenedorTabla minWidth={700}>
                  <TablaGridHeader
                    soloLectura={soloLectura}
                    template={EXTRAS_TEMPLATE(soloLectura)}
                    columnas={["Insumo", "Cantidad", "Notas"]}
                  />
                  <Form.List name="extras">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.length === 0 && (
                          <div style={{ color: "#999", padding: "10px 12px" }}>
                            {soloLectura ? "Sin extras" : "Todavía no hay extras."}
                          </div>
                        )}
                        {fields.map(({ key, name, ...restField }) => (
                          <div key={key} style={filaTablaStyle(EXTRAS_TEMPLATE(soloLectura), name)}>
                            <FormItem {...restField} name={[name, "insumoId"]} required noStyle>
                              <SelectInsumosItem
                                empresaId={this.props.empresaId}
                                headersToken={this.props.headersToken}
                                tiposInsumos="inventariables"
                                placeholder="Insumo"
                                width="100%"
                                sinBorde
                                dropdownMatchSelectWidth={600}
                                disabled={soloLectura}
                              />
                            </FormItem>
                            <FormItem {...restField} name={[name, "cantidad"]} required noStyle>
                              <InputNumberItem placeholder="0" min={0} style={{ width: "100%" }} disabled={soloLectura} />
                            </FormItem>
                            <FormItem {...restField} name={[name, "notas"]} noStyle>
                              <InputItem placeholder="Notas" disabled={soloLectura} />
                            </FormItem>
                            {!soloLectura && (
                              <div style={{ textAlign: "center" }}>
                                <MinusCircleOutlined
                                  style={{ fontSize: 16, color: "#ff4d4f", cursor: "pointer" }}
                                  onClick={() => remove(name)}
                                />
                              </div>
                            )}
                          </div>
                        ))}
                        {!soloLectura && (
                          <ButtonItem type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                            Agregar extra
                          </ButtonItem>
                        )}
                      </>
                    )}
                  </Form.List>
                </ContenedorTabla>
              </DynamicCardForm>

              <DynamicCardForm title="Notas finales" xs={24}>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <FormItem label={`Para la orden de ${tipoOrden.toLowerCase()}`} name="notas" margin>
                      <TextAreaItem
                        placeholder="Lo que el piso tiene que saber"
                        rows={3}
                        disabled={soloLectura}
                      />
                    </FormItem>
                  </Col>
                  <Col xs={24} md={12}>
                    <FormItem
                      label="Para la cotización"
                      name="notasCotizacion"
                      tooltip={{
                        title:
                          "Se copian a las Observaciones (las que se imprimen) de la cotización que se cree con \"Crear Cotización\".",
                      }}
                      margin
                    >
                      <TextAreaItem
                        placeholder="Lo que la cotización al cliente debe decir"
                        rows={3}
                        disabled={soloLectura}
                      />
                    </FormItem>
                  </Col>
                </Row>
              </DynamicCardForm>
            </Row>

            {!soloLectura && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 10,
                  justifyContent: "flex-end",
                  padding: "14px 16px",
                  background: "white",
                  borderRadius: 8,
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                }}
              >
                <ButtonItem type="default" danger onClick={this.atras.bind(this)}>
                  Cancelar
                </ButtonItem>
                <ButtonItem type="primary" htmlType="submit">
                  {modo === "editar" ? "Guardar cambios" : "Crear pre cotización"}
                </ButtonItem>
              </div>
            )}
          </Form>
        </Spin>
        <LigarCotizacion
          visible={this.state.modalLigarVisible}
          preCotizacionId={this.id}
          onCerrar={this.cerrarLigar.bind(this)}
        />
        <MandarCorreoPreCotizacion
          visible={this.state.modalCorreoVisible}
          id={this.id}
          onCerrar={this.cerrarCorreo.bind(this)}
        />
        <AgregarCliente
          visible={this.state.modalClienteVisible}
          cerrarModal={this.cerrarAgregarCliente.bind(this)}
        />
        <ModalGenerarMatriz
          visible={this.state.modalMatrizVisible}
          onCerrar={this.cerrarGenerarMatriz.bind(this)}
        />
        <ModalVerMatriz
          visible={!!this.state.matrizVista}
          matriz={this.state.matrizVista}
          onCerrar={() => this.setState({ matrizVista: null })}
        />
        <ModalGenerarOrdenesProduccion
          visible={this.state.modalOrdenesVisible}
          preCotizacionId={this.id}
          matrices={this.state.matrices}
          onCerrar={this.cerrarGenerarOrdenes.bind(this)}
        />
      </>
    );
  }
}

const MATERIALES_TEMPLATE = (soloLectura) => (soloLectura ? "4% 30% 14% 28% 24%" : "4% 28% 14% 27% 22% 5%");

const EXTRAS_TEMPLATE =(soloLectura) => (soloLectura ? "50% 15% 35%" : "46% 14% 32% 8%");

const ContenedorTabla = ({ children, minWidth }) => (
  <div
    className="pci-scroll-thin"
    style={{ overflowX: "auto", border: "1px solid #f0f0f0", borderRadius: 8 }}
  >
    <div style={{ minWidth }}>{children}</div>
  </div>
);

const TablaGridHeader = ({ columnas, template, soloLectura = true }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: template,
      gap: 6,
      padding: "8px 10px",
      background: "#fafafa",
      borderBottom: "1px solid #e8e8e8",
    }}
  >
    {columnas.map((texto) => (
      <span key={texto} style={{ fontSize: 12, fontWeight: 600, color: "#595959" }}>
        {texto}
      </span>
    ))}
    {!soloLectura && <span />}
  </div>
);

const filaTablaStyle = (template, indice) => ({
  display: "grid",
  gridTemplateColumns: template,
  gap: 6,
  alignItems: "center",
  padding: "5px 10px",
  borderBottom: "1px solid #f5f5f5",
  background: indice % 2 === 1 ? "#fcfcfc" : "white",
});

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  empresaNombre: state.empresa.nombre,
  unidadTiempoProduccion: state.empresa.unidadTiempoProduccion,
  ordenesMaquila: state.empresa.ordenesMaquila,
  permisoAgregarCotizaciones:
    state.user.tipo === 0 ||
    state.user.permisos.find((valueTodos) => valueTodos.permisoId.toString() === "6750922d798d4e0043687242")
      ?.activado,
});

export default connect(mapStateToProps)(VistaPreCotizacionIngenieria);
